<script setup lang="ts">
import { computed } from 'vue';
import LiveTrackUsageInspectorContent from '@/components/LiveTrackUsageInspectorContent.vue';
import { resolveLiveTrackId } from '@/utils/liveTrackRow';

/**
 * Inspector content for the LiveTrack "Playlist Usages" array column. Instead of the
 * generic display-string list, fetch the track's usage table (client / location — zone /
 * playlist, rows drill into the list's tracks) — the same inspector the playlist_count
 * cell opens.
 */
const props = defineProps<{
  field: string;
  dataType: string;
  data: Record<string, unknown>;
  classType: string;
}>();

const liveTrackId = computed(() => resolveLiveTrackId(props.data));
</script>

<template>
  <LiveTrackUsageInspectorContent v-if="liveTrackId != null" :live-track-id="liveTrackId" />
  <div v-else class="text-muted-foreground p-4 text-sm">
    Could not resolve the track for this row.
  </div>
</template>
